//
//
//
//
//
//
//
//
//
//
//

import storage from "@/common/storage";
export default {
    data() {
        return {
            isShow: storage.getVV() == 1
        };
    },
    $route(){
        this.isShow = storage.getVV() == 1;
    },
    methods: {
        onJump(path) {
            let VV = storage.getVV() || 0;
            VV ++;
            storage.setVV(VV);
            window.location.href = path;
        },
        onClose() {
            this.isShow = false;
        }
    }    
};



// WEBPACK FOOTER //
// ./src/components/tip-dialog.vue